module.exports = __webpack_public_path__ + "static/HR Portal Meine Daten Anstellung Organisation-376472bcff4d7727e878ee1b4ef4cfd5.jpg";